import { Component, OnInit, ViewChild } from '@angular/core';

import { LoginService } from 'app/_services/login.service';
import { BaseComponent } from 'app/base.component';
import { ResponseInterceptor } from 'app/request-interceptor';
import { LoaderService } from 'app/shared/loader/loader.service';
import { NotificationService } from 'app/shared/utils/notification.service';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'app-modal-sessao',
  templateUrl: './modal-sessao.component.html',
  styleUrls: ['./modal-sessao.component.css']
})
export class ModalSessaoComponent extends BaseComponent implements OnInit {

  public static mostrarModalRenovacao = false;

  @ViewChild('lgModalSessao') lgModalSessao: ModalDirective;
  usuario: string = null;
  nomeUsuario: string = null;
  senhaUsuario: string = null;
  mensagemExpirada = '';

  ngOnInit() {
    ResponseInterceptor.dataStream.subscribe(data => {
      this.usuario = JSON.parse(localStorage.getItem('dn-senac-seguranca'))["nomeUsuario"];
      this.nomeUsuario = JSON.parse(localStorage.getItem('dn-senac-seguranca'))["loginUsuario"];
      this.lgModalSessao.show();
    });
  }

  constructor(private loginService: LoginService,
    private loader: LoaderService,
    public notificationService: NotificationService) {
    super(notificationService);
  }

  renovarSessao() {
    // const loginUsuario = localStorage.getItem('loginUsuario');

    // if (this.senhaUsuario) {
    //   const usuario = Login.of(loginUsuario, this.senhaUsuario);

    //   this.loader.queue('exibirJanelaRenovacaoAutenticacao');

    //   this.loginService.autenticarUsuario(usuario)
    //     .subscribe(
    //       retorno => {
    //         if (retorno.data) {
    //           this.loginService.setarLocalStorageToken(retorno.data);
    //           this.exibirNotificacaoSucesso('Sessão renovada', 'Sua sessão foi renovada com sucesso.');
    //           this.fecharModal();
    //         }
    //       },
    //       erro => {
    //         this.exibirNotificacaoAlerta('Erro', 'Erro ao realizar a renovação de sessão do usuário.');
    //         this.loader.dequeue('exibirJanelaRenovacaoAutenticacao');
    //       },
    //       () => {
    //         this.loader.dequeue('exibirJanelaRenovacaoAutenticacao');
    //       }
    //     )
    // } else {
    //   this.exibirNotificacaoAlerta('Erro', 'Informe o usuário/senha de acesso para renovar sua sessão.');
    // }
  }

  abrirModal() {
    this.lgModalSessao.show();
  }

  fecharModal() {
    this.lgModalSessao.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/modal-sessao/modal-sessao.component.ts